/**
 * Cart Drawer Intercept
 * Replaces Broadcast's <product-form> click handler so ATC opens the
 * AI cart drawer instead of redirecting to /cart.
 *
 * Drop this in assets/ and reference it from layout/theme.liquid:
 *   <script src="{{ 'cart-drawer-intercept.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';
  var V = '[ATC]';
  var processed = new WeakSet();

  function swapButton(btn) {
    if (processed.has(btn)) return;
    var form = btn.form || btn.closest('form');
    if (!form) return;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;

    processed.add(btn);
    var fresh = btn.cloneNode(true);
    btn.parentNode.replaceChild(fresh, btn);
    processed.add(fresh);

    var inFlight = false;
    fresh.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (inFlight) return;
      if (fresh.hasAttribute('disabled')) return;
      if (!form.checkValidity()) { form.reportValidity(); return; }

      inFlight = true;
      fresh.setAttribute('disabled', 'disabled');
      fresh.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw j; });
          return r.json();
        })
        .then(function (data) {
          document.dispatchEvent(new CustomEvent('cart:updated'));
          // Pass the button so the drawer can return focus to it on close.
          if (typeof window.openCartDrawer === 'function') {
            window.openCartDrawer(fresh);
          } else if (window.cartDrawer && typeof window.cartDrawer.open === 'function') {
            window.cartDrawer.open(fresh);
          } else {
            console.warn(V, 'no cart drawer opener available');
          }
        })
        .catch(function (err) {
          console.error(V, 'add to cart failed:', err);
          if (err && err.description) {
            alert(err.description);
          }
        })
        .then(function () {
          inFlight = false;
          fresh.removeAttribute('disabled');
          fresh.classList.remove('is-loading');
        });
    });

    console.log(V, 'button swapped on form', form.id);
  }

  function swapAll() {
    document.querySelectorAll('[data-add-to-cart]').forEach(swapButton);
  }

  // Initial pass
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', swapAll);
  } else {
    swapAll();
  }

  // Retry passes — in case <product-form> upgrades and rebinds after our swap
  setTimeout(swapAll, 100);
  setTimeout(swapAll, 500);
  setTimeout(swapAll, 1500);

  // Watch for new ATC buttons added later (e.g. quick-add modals, AJAX updates)
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('[data-add-to-cart]')) {
          swapButton(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll('[data-add-to-cart]').forEach(swapButton);
        }
      }
    }
  });
  observer.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true
  });
})();
